import TripRateDay from "./TripRateDay";

export default class TripRateCalculationViewModel {
    arrivals: TripRateDay[] = [];
    arrivalsTotalRate: number | null = null;
    arrivalsPeak: string | null = null;
    departures: TripRateDay[] = [];
    departuresTotalRate: number | null = null;
    departuresPeak: string | null = null;
    totals: TripRateDay[] = [];
    totalsTotalRate: number | null = null;
    totalsPeak: string | null = null;
    unit: string | null = null;
    abbreviation: string | null = null;
    calculationValue: string | null = null;
    vehicleName: string | null = null;
    containsCovid: boolean = false;
}

